import {config} from "./config";
import {request} from "./request";


function createOrUpdateConfig(data, cb, fail_cb) {
    request.post.call(this, config.apiList.navSettings + "?type=" + data.type, data.icons, cb, fail_cb)
}

function getNavSettings(data, cb, fail_cb) {
    request.get.call(this, config.apiList.navSettings, data, cb, fail_cb)
}

function getDemoNavSettings(data, cb, fail_cb) {
    request.get.call(this, config.apiList.getDemoNavSettings, data, cb, fail_cb)
}

function navCustom(data, cb, fail_cb) {
    request.get.call(this, config.apiList.navCustom, data, cb, fail_cb)
}

var navSettingsApi = {
    createOrUpdateConfig: createOrUpdateConfig,
    getNavSettings: getNavSettings,
    getDemoNavSettings: getDemoNavSettings,
    navCustom: navCustom,
}

export {navSettingsApi}